import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Input } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-footer',
    standalone: true,
    imports: [CommonModule],
    template: `
        <footer class="footer" [class.sticky]="isSticky">
            <!-- Sticky Footer Content -->
            <div class="sticky-footer-content" *ngIf="isSticky">
                <div class="footer-links">
                    <a href="https://www.cloud-surfers.com/imprint" target="_blank" rel="noopener">Impressum</a>
                    <a href="https://www.cloud-surfers.com/terms" target="_blank" rel="noopener">AGB</a>
                    <a href="https://www.cloud-surfers.com/privacy" target="_blank" rel="noopener">Datenschutz</a>
                </div>
                <div class="footer-copyright">
                    <p>&copy; 2024 Cloud Surfers GmbH. Alle Rechte vorbehalten.</p>
                </div>
                <span class="footer-version" title="Version {{ version }}">v{{ version }}</span>
            </div>

            <!-- Full Footer Content -->
            <div class="full-footer-content" *ngIf="!isSticky">
            <div class="footer-content">
                <div class="footer-grid">
                    <div class="footer-section">
                        <h4>Services</h4>
                        <ul>
                            <li><a href="https://www.cloud-surfers.com/services/software-development" target="_blank" rel="noopener">Software Development</a></li>
                            <li><a href="https://www.cloud-surfers.com/services/cloud-solutions" target="_blank" rel="noopener">Cloud Solutions</a></li>
                            <li><a href="https://www.cloud-surfers.com/services/consulting" target="_blank" rel="noopener">Consulting</a></li>
                            <li><a href="https://www.cloud-surfers.com/services/support" target="_blank" rel="noopener">Support</a></li>
                        </ul>
                    </div>

                    <div class="footer-section">
                        <h4>Unternehmen</h4>
                        <ul>
                            <li><a href="https://www.cloud-surfers.com/about" target="_blank" rel="noopener">Über uns</a></li>
                            <li><a href="https://www.cloud-surfers.com/team" target="_blank" rel="noopener">Team</a></li>
                            <li><a href="https://www.cloud-surfers.com/careers" target="_blank" rel="noopener">Karriere</a></li>
                            <li><a href="https://www.cloud-surfers.com/news" target="_blank" rel="noopener">News</a></li>
                        </ul>
                    </div>

                    <div class="footer-section">
                        <h4>Kontakt</h4>
                        <ul>
                            <li><a href="mailto:info&#64;cloud-surfers.com">info&#64;cloud-surfers.com</a></li>
                            <li><a href="tel:+4915112345678">+49 151 12345678</a></li>
                            <li>Musterstraße 123<br>12345 Musterstadt</li>
                        </ul>
                    </div>

                    <div class="footer-section">
                        <h4>Legal</h4>
                        <ul>
                            <li><a href="https://www.cloud-surfers.com/privacy" target="_blank" rel="noopener">Datenschutz</a></li>
                            <li><a href="https://www.cloud-surfers.com/imprint" target="_blank" rel="noopener">Impressum</a></li>
                            <li><a href="https://www.cloud-surfers.com/terms" target="_blank" rel="noopener">AGB</a></li>
                        </ul>
                    </div>
                </div>

                <div class="footer-bottom">
                    <div class="footer-social">
                        <a href="https://linkedin.com/company/cloud-surfers" target="_blank" rel="noopener" aria-label="LinkedIn">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                            </svg>
                        </a>
                        <a href="https://github.com/cloud-surfers" target="_blank" rel="noopener" aria-label="GitHub">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                            </svg>
                        </a>
                        <a href="https://twitter.com/cloudsurfers" target="_blank" rel="noopener" aria-label="Twitter">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                            </svg>
                        </a>
                    </div>
                    <div class="footer-copyright">
                        <p>&copy; 2024 Cloud Surfers GmbH. Alle Rechte vorbehalten.&nbsp;<span class="footer-version" title="Version {{ version }}">v{{ version }}</span></p>
                    </div>
                </div>
            </div>
            </div>
        </footer>
    `,
    styles: [`
        .footer {
            background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
            color: white;
        }

        .footer:not(.sticky) {
            margin-top: auto;
        }

        .footer.sticky {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 100;
            box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
        }

        .sticky-footer-content {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0.75rem 1.5rem;
            max-width: 1200px;
            margin: 0 auto;
        }

        .footer-links {
            display: flex;
            gap: 2rem;
        }

        .footer-links a {
            color: rgba(255, 255, 255, 0.9);
            text-decoration: none;
            font-size: 0.875rem;
            font-weight: 500;
            transition: color 0.3s ease;
        }

        .footer-links a:hover {
            color: #ffffff;
            text-decoration: underline;
        }

        .sticky-footer-content .footer-copyright p {
            margin: 0;
            font-size: 0.875rem;
            color: rgba(255, 255, 255, 0.8);
            font-weight: 400;
        }

        .footer-version {
            font-size: 0.7rem;
            color: rgba(255, 255, 255, 0.35);
        }

        .footer-content {
            max-width: 1200px;
            margin: 0 auto;
            padding: 3rem 1.5rem 1.5rem;
        }

        .footer-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
            gap: 2rem;
            margin-bottom: 2rem;
        }

        .footer-section h4 {
            color: #ffffff;
            font-size: 1.1rem;
            font-weight: 600;
            margin-bottom: 1rem;
            border-bottom: 2px solid rgba(255, 255, 255, 0.2);
            padding-bottom: 0.5rem;
        }

        .footer-section ul {
            list-style: none;
            padding: 0;
            margin: 0;
        }

        .footer-section li {
            margin-bottom: 0.5rem;
        }

        .footer-section a {
            color: rgba(255, 255, 255, 0.8);
            text-decoration: none;
            font-size: 0.9rem;
            transition: color 0.3s ease;
        }

        .footer-section a:hover {
            color: #ffffff;
            text-decoration: underline;
        }

        .footer-bottom {
            border-top: 1px solid rgba(255, 255, 255, 0.2);
            padding-top: 1.5rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            gap: 1rem;
        }

        .footer-social {
            display: flex;
            gap: 1rem;
        }

        .footer-social a {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 40px;
            height: 40px;
            background-color: rgba(255, 255, 255, 0.1);
            border-radius: 50%;
            color: rgba(255, 255, 255, 0.8);
            transition: all 0.3s ease;
        }

        .footer-social a:hover {
            background-color: rgba(255, 255, 255, 0.2);
            color: #ffffff;
            transform: translateY(-2px);
        }

        .footer-copyright p {
            margin: 0;
            font-size: 0.85rem;
            color: rgba(255, 255, 255, 0.7);
        }

        @media (max-width: 768px) {
            .sticky-footer-content {
                flex-direction: column;
                gap: 0.5rem;
                padding: 0.5rem 1rem;
                text-align: center;
            }

            .footer-links {
                gap: 1.5rem;
                flex-wrap: wrap;
                justify-content: center;
            }

            .footer-links a {
                font-size: 0.8rem;
            }

            .sticky-footer-content .footer-copyright p {
                font-size: 0.8rem;
            }

            .footer-content {
                padding: 2rem 1rem 1rem;
            }

            .footer-grid {
                grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
                gap: 1.5rem;
            }

            .footer-bottom {
                flex-direction: column;
                text-align: center;
                gap: 1rem;
            }

            .footer-social {
                order: -1;
            }
        }

        @media (max-width: 480px) {
            .footer-links {
                gap: 1rem;
            }

            .footer-links a {
                font-size: 0.75rem;
            }

            .sticky-footer-content .footer-copyright p {
                font-size: 0.75rem;
            }

            .footer-grid {
                grid-template-columns: 1fr;
                gap: 1rem;
            }

            .footer-section {
                text-align: center;
            }
        }
    `]
})
export class FooterComponent {
    @Input() isSticky: boolean = false;
    version = environment.version;
}